import { Box } from '@mui/material';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTheme } from '@mui/material/styles';

export default forwardRef(({ onChange, sitekey, className, asyncScriptOnLoad, onExpired }, ref) => {
  const { i18n } = useTranslation();
  const { palette } = useTheme();

  return (
    <Box>
      <ReCAPTCHA
        ref={ref}
        sitekey={sitekey}
        hl={i18n.language}
        onChange={onChange}
        key={i18n.language}
        theme={palette.mode}
        className={className}
        onExpired={onExpired}
        asyncScriptOnLoad={asyncScriptOnLoad}
      />
    </Box>
  );
});
